import { Box, Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { NavLink as RouterLink } from 'react-router-dom';

const ToolbarActions = () => {
  const { t } = useTranslation('presentations');

  return (
    <Box display="flex" justifyContent="flex-end">
      <Button
        color="primary"
        variant="contained"
        component={RouterLink}
        to="/app/presentations/create"
      >
        {t('buttons.presentations_list_create_presentation')}
      </Button>
    </Box>
  );
};

ToolbarActions.propTypes = {};

export default ToolbarActions;
